// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3XSaY","row":"Node_row__2SaTz","label":"Node_label__3B6d9","footer":"Node_footer__1rqD9"};